<template>
  <div class="container">
    <div class="is-centered">
      <div>
        <ValidationObserver
          v-slot="{ errors }"
          tag="div"
        >
          <input-form
            ref="form"
            :errors="errors"
            name="ResubmissionFrm"
            @submit.prevent="submit"
          >
            <h1 v-if="edpstatus == 1">
              TFA Resubmission Form
            </h1>
            <h1 v-if="edpstatus != 1">
              EDP Application Resubmission Form
            </h1>
            <callout
              v-if="edpstatus == 1"
              type="info"
            >
              Landlords: Please use this form to submit new information related to your Eviction Diversion Application: {{ applicantId }} for the tenant(s) {{ initTenantName }} at the rental unit {{ TenantAddress }}. 
              Each of the item(s) below were flagged during the review of your eligibility for Targeted Financial Assistance (TFA). In order for the City's Financial Specialist to complete this review you must provide the following information and/or documents.
            </callout>
            <callout
              v-if="edpstatus != 1"
              type="info"
            >
              Landlords: Please use this form to submit new information related to your Eviction Diversion Application: {{ applicantId }} for the tenant(s) {{ initTenantName }} at the rental unit {{ TenantAddress }}.   
              Each of the item(s) below were flagged during the review process and need to be corrected before an application can be approved.
            </callout>

            <callout
              v-if="edpstatus != 1"
              type="warning"
            >
              Please DO NOT REAPPLY. Simply use this form to correct issues on your existing application. Corrections must be submitted within 30 days of application creation or you will need to create a new application.
            </callout>

            

            <div v-if="edpstatus == 1">
              <vee-radio
                id="radio-tfa-withdraw"
                v-model="WithdrawTFA"
                :options="MultipleChoiceFieldOptions.YesNo"
                rules="required"
                required
                error="This field is required"
                label="Are you withdrawing from TFA?"
              />
            </div>
            <div v-if="WithdrawTFA === 'Yes'">
              <callout type="info">
                Thank you for letting us know. 
                Your TFA application will be closed. 
                You must participate in negotiation with your tenant through the end of the program period before filing for eviction in municipal court. 
                Please click the “Finish” button below to submit your response.
              </callout>
            </div>
            
            <div v-if="(!(resubmissions > 10) && WithdrawTFA != 'Yes') || (!(resubmissions > 10) && edpstatus != 1)">
              <div v-if="licensenumber == 1">
                <h4>Rental License Number</h4>
                <callout type="warning">
                  A valid rental license is required to participate in this program. The rental license number included on your application {{ CurrentRentalLicenseNumber }} could not be verified. If you have an active license, please provide corrected information here:  
                </callout>
              </div>
              <div v-if="licensenumber == 1">
                <div
                  class="columns"
                >
                  <div class="column">
                    <vee-textbox
                      v-model="Landlord.RentalLicenseNumber"
                      name="txt-landlord-rental-license-number"
                      placeholder="Enter your rental license number"
                      rules="required"
                      required
                      @input="getRentalLicense"
                      @keydown.enter.prevent=""
                    />
                  </div>
                </div>
                <div style="margin-left: 1%;">
                  <h5>
                    Active Rental License*:
                  </h5>
                  <ul id="upload-list-account-documents">
                    <li
                      v-for="file in RentalLicenseDocument"
                      :key="file.id"
                    >
                      <span>{{ file.name }} - </span>
                      <span
                        v-if="file.error"
                        class="is-love-park-red"
                      >
                        Something went wrong - {{ file.errorMessage }}
                      </span>

                      <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                      >
                        Upload Successful.
                      </span>
                      <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                      >
                        Uploading Document...</span>
                    </li>
                  </ul>
                  <file-upload
                    ref="upload"
                    v-model="RentalLicenseDocument"
                    :input-id="`file-upload-rental-license`"
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :size="1024 * 1024 * 4.5"
                    @input-filter="inputFilter"
                  >
                    <button class="button is-primary">
                      <i class="fa fa-plus" />
                      Select File to Upload
                    </button>
                  </file-upload>
                </div>
                <br>
              </div>
              
              <callout
                v-if="licensenumber == 1"
                type="warning"
              >
                If you do not have an active rental license, please visit this page to obtain one: <a href="https://www.phila.gov/services/permits-violations-licenses/get-a-license/business-licenses/rental-and-property/get-a-rental-license/">https://www.phila.gov/services/permits-violations-licenses/get-a-license/business-licenses/rental-and-property/get-a-rental-license/</a>.  

 

                If you need additional assistance obtaining a license, please contact: <a href="mailto:landlords@phila.gov">landlords@phila.gov</a> or <a href="tel:+12456867182">(215) 686-7182</a>.
              </callout>
              <div v-if="llname == 1 || llemail == 1 || llphone == 1">
                <h4>Property Owner Contact Information</h4>
                <callout type="warning">
                  Invalid property owner contact information was submitted for the field below. Please provide corrected information here:
                </callout>
              </div>
              <div
                v-if="llname == 1"
                class="columns"
              >
                <div
                  class="column"
                >
                  <vee-textbox
                    id="property-owner-first-name"
                    v-model="Landlord.ContactInformation.FirstName"
                    mode="eager"
                    name="txt-property-owner-landlord-first-name"
                    placeholder="First Name"
                    rules="required|whitespace"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div
                  class="column"
                >
                  <vee-textbox
                    id="property-owner-last-name"
                    v-model="Landlord.ContactInformation.LastName"
                    mode="eager"
                    name="txt-property-owner-landlord-last-name"
                    placeholder="Last Name"
                    rules="required|whitespace"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <br>
              </div>
              <div
                v-if="llphone == 1 || llemail == 1"
                class="columns"
              >
                <div
                  v-if="llphone == 1"
                  class="column"
                >
                  <vee-textbox
                    id="property-owner-cell-phone"
                    v-model="Landlord.ContactInformation.CellPhone"
                    mode="eager"
                    name="txt-property-owner-landlord-cell-phone"
                    placeholder="Phone Number"
                    rules="required|phone"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div
                  v-if="llemail == 1"
                  class="column"
                >
                  <vee-textbox
                    id="property-owner-email"
                    v-model="Landlord.ContactInformation.EmailAddress"
                    mode="eager"
                    name="txt-property-owner-landlord-email-address"
                    placeholder="Email Address"
                    rules="required|email"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <br>
              </div>
              <div v-if="marname == 1 || maremail == 1 || marphone == 1">
                <h4>Authorized Representative Completing Application - Contact Information</h4>
                <callout type="warning">
                  Invalid authorized representative contact information was submitted for the field below. Please provide corrected information here:
                </callout>
              </div>
              <div
                v-if="marname == 1"
                class="columns"
              >
                <div class="column">
                  <vee-textbox
                    id="property-management-representative-first-name"
                    v-model="
                      PropertyManagementRepresentative.ContactInformation
                        .FirstName
                    "
                    mode="eager"
                    name="txt-property-management-representative-first-name"
                    placeholder="First Name"
                    rules="required|whitespace"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div class="column">
                  <vee-textbox
                    id="property-management-representative-last-name"
                    v-model="
                      PropertyManagementRepresentative.ContactInformation
                        .LastName
                    "
                    mode="eager"
                    name="txt-property-management-representative-last-name"
                    placeholder="Last Name"
                    rules="required|whitespace"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <br>
              </div>
              <div
                v-if="maremail == 1 || marphone == 1"
                class="columns"
              >
                <div
                  v-if="marphone == 1"
                  class="column"
                >
                  <vee-textbox
                    id="property-management-representative-phone"
                    v-model="
                      PropertyManagementRepresentative.ContactInformation
                        .CellPhone
                    "
                    mode="eager"
                    name="txt-property-management-representative-cell-phone"
                    placeholder="Cell Phone Number (for text message notifications &amp; updates)"
                    type="tel"
                    required
                    rules="required|phone"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div
                  v-if="maremail == 1"
                  class="column"
                >
                  <vee-textbox
                    id="property-management-representative-email"
                    v-model="
                      PropertyManagementRepresentative.ContactInformation
                        .EmailAddress
                    "
                    mode="eager"
                    name="txt-property-management-representative-email-address"
                    placeholder="Email Address"
                    required
                    rules="required|email"
                    @keydown.enter.prevent=""
                  />
                </div>
              </div>
              <div v-if="pmrarname == 1 || pmraremail == 1 || pmrarphone == 1">
                <h4>Authorized Representative Attending Mediation - Contact Information</h4>
                <callout type="warning">
                  Invalid authorized representative contact information was submitted for the field below. Please provide corrected information here:
                </callout>
              </div>
              <div
                v-if="pmrarname == 1"
                class="columns"
              >
                <div class="column">
                  <vee-textbox
                    id="mediation-rep-first-name"
                    v-model="
                      PropertyManagementRepresentative.ContactInformation
                        .MediationRepFirstName
                    "
                    mode="eager"
                    name="txt-mediation-rep-first-name"
                    placeholder="First Name"
                    rules="required|whitespace"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div class="column">
                  <vee-textbox
                    id="mediation-rep-last-name"
                    v-model="
                      PropertyManagementRepresentative.ContactInformation
                        .MediationRepLastName
                    "
                    mode="eager"
                    name="txt-mediation-rep-last-name"
                    placeholder="Last Name"
                    rules="required|whitespace"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <br>
              </div>
              <div
                v-if="pmraremail == 1 || pmrarphone == 1"
                class="columns"
              >
                <div
                  v-if="pmrarphone == 1"
                  class="column"
                >
                  <vee-textbox
                    id="mediation-rep-phone"
                    v-model="
                      PropertyManagementRepresentative.ContactInformation
                        .MediationRepPhone
                    "
                    mode="eager"
                    name="txt-mediation-rep-phone"
                    placeholder="Cell Phone Number (for text message notifications &amp; updates)"
                    type="tel"
                    required
                    error="This field is required"
                    rules="required|phone"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div
                  v-if="pmraremail == 1"
                  class="column"
                >
                  <vee-textbox
                    id="mediation-rep-email"
                    v-model="
                      PropertyManagementRepresentative.ContactInformation
                        .MediationRepEmail
                    "
                    mode="eager"
                    name="mediation-rep-email-address"
                    placeholder="Email Address"
                    required
                    error="This field is required"
                    rules="required|email"
                    @keydown.enter.prevent=""
                  />
                  <br>
                </div>
              </div>
              <div v-if="tname == 1 || tphone == 1 || temail == 1">
                <h4>Primary Tenant Contact Information</h4>
                <callout type="warning">
                  Invalid tenant contact information was submitted for the field below. Please provide corrected information here:
                </callout>
                <div v-if="TenantNotes != null">
                  <label><b>Tenant Review Notes</b></label>
                  <callout type="info">
                    {{ TenantNotes }}
                  </callout>
                  <p />
                </div>
              </div>
              <div
                v-if="tname == 1"
                class="columns"
              >
                <div class="column">
                  <vee-textbox
                    id="tenant-first-name"
                    v-model="Tenant.ContactInformation.FirstName"
                    mode="eager"
                    :name="`txt-tenant-first-name`"
                    placeholder="Tenant First Name"
                    rules="required|whitespace"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div class="column">
                  <vee-textbox
                    id="tenant-last-name"
                    v-model="Tenant.ContactInformation.LastName"
                    mode="eager"
                    :name="`txt-tenant-last-name`"
                    placeholder="Tenant Last Name"
                    rules="required|whitespace"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <br>
              </div>
              <div
                v-if="tphone == 1 || temail == 1"
                class="columns"
              >
                <div
                  v-if="temail == 1"
                  class="column"
                >
                  <vee-textbox
                    id="tenant-email-address"
                    v-model="Tenant.ContactInformation.EmailAddress"
                    mode="eager"
                    :name="`txt-tenant-email-address`"
                    placeholder="Tenant Email Address"
                    rules="required|email"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div
                  v-if="tphone == 1"
                  class="column"
                >
                  <vee-textbox
                    id="tenant-phone"
                    v-model="Tenant.ContactInformation.CellPhone"
                    mode="eager"
                    :name="`txt-tenant-phone`"
                    placeholder="Tenant Phone Number"
                    rules="required|phone"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <br>
              </div>
              <div v-if="tenantaddress == 1">
                <h3>Tenant Address</h3>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                      id="txt-tenant-address-street1"
                      v-model="Tenant.ContactInformation.Address.Street1"
                      mode="eager"
                      name="txt-tenant-address-street1"
                      placeholder="Street Address"
                      rules="required"
                      required
                      error="This field is required"
                      @keydown.enter.prevent=""
                    />
                  </div>
                  <div class="column">
                    <textbox
                      v-model="Tenant.ContactInformation.Address.Street2"
                      name="txt-tenant-address-street2"
                      placeholder="Apt / Unit"
                    />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                      v-model="Tenant.ContactInformation.Address.City"
                      mode="eager"
                      name="txt-tenant-address-city"
                      placeholder="City"
                      readonly
                      @keydown.enter.prevent=""
                    />
                  </div>
                  <div class="column">
                    <vee-textbox
                      v-model="Tenant.ContactInformation.Address.State"
                      mode="eager"
                      name="txt-tenant-address-state"
                      placeholder="State"
                      readonly
                      @keydown.enter.prevent=""
                    />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                      id="txt-tenant-address-zip"
                      v-model="Tenant.ContactInformation.Address.Zip"
                      mode="eager"
                      name="txt-tenant-address-zip"
                      placeholder="ZIP Code"
                      rules="required"
                      required
                      error="This field is required"
                      @keydown.enter.prevent=""
                    />
                  </div>
                  <div class="column">
                    <vee-textbox
                      v-model="Tenant.ContactInformation.Address.Country"
                      label="Country"
                      readonly
                      @keydown.enter.prevent=""
                    />
                  </div>
                </div>
              </div>
              <!-- <div v-if="tname == 1 || tphone == 1 || temail == 1">
                <h4>Secondary Tenant Contact Information</h4>
                <callout type="warning">
                  Invalid tenant contact information was submitted for the field below. Please provide corrected information here:
                </callout>
              </div>
              <div
                v-if="tname == 1"
                class="columns"
              >
                <div class="column">
                  <vee-textbox
                    id="tenant-first-name"
                    v-model="Tenant.ContactInformation.SecondaryFirstName"
                    mode="eager"
                    :name="`txt-secondary-tenant-first-name`"
                    placeholder="Secondary Tenant First Name"
                    rules="required"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div class="column">
                  <vee-textbox
                    id="tenant-last-name"
                    v-model="Tenant.ContactInformation.SecondaryLastName"
                    mode="eager"
                    :name="`txt-secondary-tenant-last-name`"
                    placeholder="Secondary Tenant Last Name"
                    rules="required"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
              </div>
              <div
                v-if="tphone == 1 || temail == 1"
                class="columns"
              >
                <div
                  v-if="temail == 1"
                  class="column"
                >
                  <vee-textbox
                    id="tenant-email-address"
                    v-model="Tenant.ContactInformation.SecondaryEmailAddress"
                    mode="eager"
                    :name="`txt-secondary-tenant-email-address`"
                    placeholder="SecondaryTenant Email Address"
                    rules="required|email"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
                <div
                  v-if="tphone == 1"
                  class="column"
                >
                  <vee-textbox
                    id="tenant-phone"
                    v-model="Tenant.ContactInformation.SecondaryPhoneNumberCellPhone"
                    mode="eager"
                    :name="`txt-secondary-tenant-phone`"
                    placeholder="Secondary Tenant Phone Number"
                    rules="required|phone"
                    required
                    error="This field is required"
                    @keydown.enter.prevent=""
                  />
                </div>
              </div> -->

              <div v-if="bankstatement == 1">
                <h4>Bank Information</h4>
                <callout
                  v-if="BankInfo.BankDocument.length == 0"
                  type="warning"
                >
                  Missing or invalid banking information was submitted. Please provide corrected information here:
                </callout>
                <div v-if="BankNotes != null">
                  <label><b>Bank Review Notes</b></label>
                  <callout type="info">
                    {{ BankNotes }}
                  </callout>
                  <p />
                </div>
                <div
                  class="columns"
                >
                  <div class="column">
                    <vee-textbox
                      v-model="BankInfo.BankName"
                      name="input-bank-name"
                      required
                      error="This field is required"
                      rules="required"
                      placeholder="Bank Name"
                      type="text"
                      @keydown.enter.prevent=""
                    />
                  </div>
                  <div
                    v-if="bankaccountname == 1"
                    class="column"
                  >
                    <vee-textbox
                      v-model="BankInfo.NameOnBankAccount"
                      name="input-bank-account-name"
                      required
                      error="This field is required"
                      rules="required|whitespace"
                      placeholder="Name on bank account"
                      type="text"
                      @keydown.enter.prevent=""
                    />
                  </div>
                  <br>
                </div>
                <div class="columns">
                  <div class="column">
                    <vee-textbox
                      id="accountNumber"
                      v-model="BankInfo.AccountNumber"
                      name="input-account-number"
                      required
                      error="This field is required"
                      rules="required|numeric"
                      placeholder="Account Number"
                      type="password"
                      @keydown.enter.prevent=""
                    />
                    <input
                      type="checkbox"
                      style="margin-left: 2%"
                      @click="showValue('accountNumber')"
                    > Show Account Number
                  </div>
                  <div class="column">
                    <vee-textbox
                      id="routingNumber"
                      v-model="BankInfo.RoutingNumber"
                      name="input-account-number"
                      required
                      error="This field is required"
                      rules="required|numeric"
                      placeholder="Routing Number"
                      type="password"
                      @keydown.enter.prevent=""
                    />
                    <input
                      type="checkbox"
                      style="margin-left: 2%"
                      @click="showValue('routingNumber')"
                    > Show Routing Number
                  </div>
                  <br>
                </div>
                <div style="margin-left: 1%;">
                  <h5>
                    Upload bank document (cancelled check or statement)*:
                  </h5>
                  <ul id="upload-list-account-documents">
                    <li
                      v-for="file in BankInfo.BankDocument"
                      :key="file.id"
                    >
                      <span>{{ file.name }} - </span>
                      <span
                        v-if="file.error"
                        class="is-love-park-red"
                      >
                        Something went wrong - {{ file.errorMessage }}
                      </span>

                      <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                      >
                        Upload Successful.
                      </span>
                      <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                      >
                        Uploading Document...</span>
                    </li>
                  </ul>
                  <file-upload
                    ref="upload"
                    v-model="BankInfo.BankDocument"
                    :input-id="`file-upload-bank-document`"
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :size="1024 * 1024 * 4.5"
                    @input-filter="inputFilter"
                  >
                    <button class="button is-primary">
                      <i class="fa fa-plus" />
                      Select File to Upload
                    </button>
                  </file-upload>
                </div>
                <br>
              </div>

              <div v-if="nine == 1 || ssn == 1">
                <h4>EIN Number or SSN Information</h4>
              
                <callout
                  v-if="W9Info.W9Document.length == 0"
                  type="warning"
                >
                  Missing or invalid EIN or SSN was submitted. Please provide corrected information here: 
                </callout>
              </div>
              <div
                v-if="nine == 1 || ssn == 1"
                class="columns"
              >
                <div class="column">
                  <callout type="warning">
                    Please fill out either W9 EIN Number or SSN
                  </callout>
                  <div
                    class="columns"
                  >
                    <div
                      v-if="W9Info.SSN == null || W9Info.SSN == ''"
                      class="column"
                    >
                      <vee-textbox
                        id="w9EINNumber"
                        v-model="W9Info.W9EINNumber"
                        name="input-ein-number"
                        required
                        error="This field is required"
                        rules="required|numeric"
                        placeholder="W9 EIN Number"
                        type="password"
                        @keydown.enter.prevent=""
                      />
                      <input
                        type="checkbox"
                        style="margin-left: 1%"
                        @click="showValue('w9EINNumber')"
                      > Show EIN
                    </div>
                    <div
                      v-if="W9Info.W9EINNumber == null || W9Info.W9EINNumber == ''"
                      class="column"
                    >
                      <vee-textbox
                        id="ssnNumber"
                        v-model="W9Info.SSN"
                        name="input-ssn-number"
                        required
                        error="This field is required"
                        rules="required|numeric"
                        placeholder="SSN Number"
                        type="password"
                        @keydown.enter.prevent=""
                      />
                      <input
                        type="checkbox"
                        style="margin-left: 1%"
                        @click="showValue('ssnNumber')"
                      > SSN
                    </div>
                  </div>
                  <br>
                  <br>
                  <div v-if="w9address == 1">
                    <h3>W9 Address</h3>
                    <div class="columns">
                      <div class="column">
                        <vee-textbox
                          id="txt-w9-address-street1"
                          v-model="W9Info.Address.Street1"
                          mode="eager"
                          name="txt-tenant-address-street1"
                          placeholder="Street Address"
                          rules="required"
                          required
                          error="This field is required"
                          @keydown.enter.prevent=""
                        />
                      </div>
                      <div class="column">
                        <vee-textbox
                          v-model="W9Info.Address.Street2"
                          name="txt-w9-address-street2"
                          placeholder="Apt / Unit"
                          @keydown.enter.prevent=""
                        />
                      </div>
                      <br>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <vee-textbox
                          v-model="W9Info.Address.City"
                          mode="eager"
                          name="txt-w9-address-city"
                          placeholder="City"
                          rules="required"
                          required
                          error="This field is required"
                          @keydown.enter.prevent=""
                        />
                      </div>
                      <div class="column">
                        <vee-dropdown
                          v-model="W9Info.Address.State"
                          mode="eager"
                          name="txt-w9-address-state"
                          :options="States"
                          placeholder="State"
                          rules="required"
                          required
                          error="This field is required"
                          @keydown.enter.prevent=""
                        />
                      </div>
                      <br>
                    </div>
                    <div class="columns">
                      <div class="column">
                        <vee-textbox
                          id="txt-tenant-address-zip"
                          v-model="W9Info.Address.Zip"
                          mode="eager"
                          name="txt-w9-address-zip"
                          placeholder="ZIP Code"
                          rules="required"
                          required
                          error="This field is required"
                          @keydown.enter.prevent=""
                        />
                      </div>
                      <div class="column">
                        <vee-textbox
                          v-model="W9Info.Address.Country"
                          label="Country"
                          placeholder="Country"
                          rules="required"
                          required
                          error="This field is required"
                          @keydown.enter.prevent=""
                        />
                      </div>
                      <br>
                    </div>
                  </div>
                  <div style="margin-left: 1%;">
                    <br>
                    <h5>
                      Upload current W9 (W9 must match bank account provided above)* 
                    </h5>
                    <ul id="upload-list-account-documents">
                      <li
                        v-for="file in W9Info.W9Document"
                        :key="file.id"
                      >
                        <span>{{ file.name }} - </span>
                        <span
                          v-if="file.error"
                          class="is-love-park-red"
                        >
                          Something went wrong - {{ file.errorMessage }}
                        </span>

                        <span
                          v-else-if="file.success"
                          class="is-phanatic-green"
                        >
                          Upload Successful.
                        </span>
                        <span
                          v-else-if="file.uploading"
                          class="is-flyers-orange"
                        >
                          Uploading Document...</span>
                      </li>
                    </ul>
                    <file-upload
                      ref="upload"
                      v-model="W9Info.W9Document"
                      :input-id="`file-upload-W9-document`"
                      extensions="gif,jpg,jpeg,png,webp,pdf"
                      accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                      :size="1024 * 1024 * 4.5"
                      @input-filter="inputFilter"
                    >
                      <button class="button is-primary">
                        <i class="fa fa-plus" />
                        Select File to Upload
                      </button>
                    </file-upload>
                  </div>
                </div>
                <br>
              </div>

              <div v-if="ledger == 1">
                <div class="columns">
                  <div class="column">
                    <callout type="warning">
                      <b>If you are updating this figure to apply to TFA, entering an amount greater than $3,500 will cause your application to be marked ineligible.</b>
                    </callout>
                    <vee-textbox
                      v-model="Arrears"
                      mode="eager"
                      :name="`txt-arrears`"
                      placeholder="Amount of back rent or fees that you are seeking"
                      rules="required|minimumArrears|doubleCurrencyArrears:2"
                      required
                      error="This field is required"
                      @keydown.enter.prevent=""
                    />
                  </div>
                </div>
                <div style="margin-left: 1%;">
                  <h5>
                    Ledger*:
                  </h5>
                  <callout
                    v-if="LedgerDocument.length == 0"
                    type="warning"
                  >
                    Missing or invalid ledger was submitted. Please provide corrected information here: 
                  </callout>
                  <div v-if="LedgerNotes != null">
                    <label><b>Ledger Review Notes</b></label>
                    <callout type="info">
                      {{ LedgerNotes }}
                    </callout>
                  </div>
                  <ul id="upload-list-account-documents">
                    <li
                      v-for="file in LedgerDocument"
                      :key="file.id"
                    >
                      <span>{{ file.name }} - </span>
                      <span
                        v-if="file.error"
                        class="is-love-park-red"
                      >
                        Something went wrong - {{ file.errorMessage }}
                      </span>

                      <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                      >
                        Upload Successful.
                      </span>
                      <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                      >
                        Uploading Document...</span>
                    </li>
                  </ul>
                  <file-upload
                    ref="upload"
                    v-model="LedgerDocument"
                    :input-id="`file-upload-ledger-document`"
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :size="1024 * 1024 * 4.5"
                    @input-filter="inputFilter"
                  >
                    <button class="button is-primary">
                      <i class="fa fa-plus" />
                      Select File to Upload
                    </button>
                  </file-upload>
                </div>
                <br>
              </div>

              <div v-if="affidavit == 1">
                <div style="margin-left: 1%;">
                  <h5>
                    Signed <a
                      :href="$landlordAffidavit"
                      target="_blank"
                    ><u>landlord affidavit</u></a> (<a
                      :href="$landlordAffidavitSpanish"
                      target="_blank"
                    ><u>Spanish landlord affidavit</u></a>)*:
                  </h5>
                  <callout
                    v-if="Affidavit.length == 0"
                    type="warning"
                  >
                    Missing or invalid landlord affidavit submitted. Please provide corrected information here: 
                  </callout>
                  <div v-if="AffidavitNotes != null">
                    <label><b>Affidavit Review Notes</b></label>
                    <callout type="info">
                      {{ AffidavitNotes }}
                    </callout>
                  </div>
                  <ul id="upload-list-account-documents">
                    <li
                      v-for="file in Affidavit"
                      :key="file.id"
                    >
                      <span>{{ file.name }} - </span>
                      <span
                        v-if="file.error"
                        class="is-love-park-red"
                      >
                        Something went wrong - {{ file.errorMessage }}
                      </span>

                      <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                      >
                        Upload Successful.
                      </span>
                      <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                      >
                        Uploading Document...</span>
                    </li>
                  </ul>
                  <file-upload
                    ref="upload"
                    v-model="Affidavit"
                    :input-id="`file-upload-affidavit-document`"
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :size="1024 * 1024 * 4.5"
                    @input-filter="inputFilter"
                  >
                    <button class="button is-primary">
                      <i class="fa fa-plus" />
                      Select File to Upload
                    </button>
                  </file-upload>
                </div>
                <br>
              </div>

              <div v-if="nor == 1">
                <div style="margin-left: 1%;">
                  <h5>
                    Upload proof that a <a
                      :href="$norDocument"
                      target="_blank"
                    ><u>Notice of Diversion Rights</u></a> was delivered
                  </h5>
                  <callout
                    v-if="NoticeOfDiversionRights.length == 0"
                    type="warning"
                  >
                    Missing or invalid Proof of Notice of Diversion Rights was submitted. Please provide corrected information here: 
                  </callout>
                  <ul id="upload-list-account-documents">
                    <li
                      v-for="file in NoticeOfDiversionRights"
                      :key="file.id"
                    >
                      <span>{{ file.name }} - </span>
                      <span
                        v-if="file.error"
                        class="is-love-park-red"
                      >
                        Something went wrong - {{ file.errorMessage }}
                      </span>

                      <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                      >
                        Upload Successful.
                      </span>
                      <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                      >
                        Uploading Document...</span>
                    </li>
                  </ul>
                  <file-upload
                    ref="upload"
                    v-model="NoticeOfDiversionRights"
                    :input-id="`file-upload-nor-document`"
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :size="1024 * 1024 * 4.5"
                    @input-filter="inputFilter"
                  >
                    <button class="button is-primary">
                      <i class="fa fa-plus" />
                      Select File to Upload
                    </button>
                  </file-upload>
                </div>
                <br>
              </div>

              <div v-if="rentproof == 1">
                <div style="margin-left: 1%;">
                  <h5>
                    Proof of Rent*:
                  </h5>
                  <callout
                    v-if="ProofOfRent.length == 0"
                    type="warning"
                  >
                    Missing or invalid Proof of Rent was submitted. Please provide corrected information here:
                  </callout>
                  <ul id="upload-list-account-documents">
                    <li
                      v-for="file in ProofOfRent"
                      :key="file.id"
                    >
                      <span>{{ file.name }} - </span>
                      <span
                        v-if="file.error"
                        class="is-love-park-red"
                      >
                        Something went wrong - {{ file.errorMessage }}
                      </span>

                      <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                      >
                        Upload Successful.
                      </span>
                      <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                      >
                        Uploading Document...</span>
                    </li>
                  </ul>
                  <file-upload
                    ref="upload"
                    v-model="ProofOfRent"
                    :input-id="`file-upload-rent-document`"
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :size="1024 * 1024 * 4.5"
                    @input-filter="inputFilter"
                  >
                    <button class="button is-primary">
                      <i class="fa fa-plus" />
                      Select File to Upload
                    </button>
                  </file-upload>
                </div>
                <br>
              </div>

              <div v-if="lease == 1">
                <div style="margin-left: 1%;">
                  <h5>
                    Lease*:
                  </h5>
                  <callout
                    v-if="Lease.length == 0"
                    type="warning"
                  >
                    Missing or invalid current lease was submitted. Please provide corrected information here:  
                  </callout>
                  <ul id="upload-list-account-documents">
                    <li
                      v-for="file in Lease"
                      :key="file.id"
                    >
                      <span>{{ file.name }} - </span>
                      <span
                        v-if="file.error"
                        class="is-love-park-red"
                      >
                        Something went wrong - {{ file.errorMessage }}
                      </span>

                      <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                      >
                        Upload Successful.
                      </span>
                      <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                      >
                        Uploading Document...</span>
                    </li>
                  </ul>
                  <file-upload
                    ref="upload"
                    v-model="Lease"
                    :input-id="`file-upload-lease-document`"
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :size="1024 * 1024 * 4.5"
                    @input-filter="inputFilter"
                  >
                    <button class="button is-primary">
                      <i class="fa fa-plus" />
                      Select File to Upload
                    </button>
                  </file-upload>
                </div>
                <br>
              </div>
              <div
                v-if="businees == 1"
                class="columns"
              >
                <div class="column">
                  <vee-textbox
                    v-model="PropertyOwnerBusinessName"
                    name="input-business-name"
                    required
                    error="This field is required"
                    rules="required"
                    placeholder="Property owner's business name"
                    type="text"
                    @keydown.enter.prevent=""
                  />
                </div>
                <br>
              </div>
              <!-- <div class="columns">
                <div class="column">
                  <input
                    v-model="PropertyOwnerCheckbox"
                    style="margin-right: 8px; vertical-align: middle;"
                    true-value="1"
                    false-value="0"
                    type="checkbox"
                  >
                  <label style="vertical-align: middle;">I am the owner of the property and the property is listed in my name.</label>
                </div>
              </div> -->
              <div
                v-if="authorization == 1 && PropertyOwnerCheckbox == false"
                style="margin-left: 1%;"
              >
                <h5>Authorization Document:</h5>
                <callout
                  type="warning"
                >
                  Missing or invalid authorization document. Please provide corrected information here: 
                </callout>

                <div v-if="AuthorizationNotes != null">
                  <label><b>Authorization Review Notes</b></label>
                  <callout type="info">
                    {{ AuthorizationNotes }}
                  </callout>
                  <p />
                </div>
                <div>
                  <h5>
                    You are required to submit proof that you are authorized to make decisions for this property:*
                    <table style="border-width: 2px; border-style: solid; width: 94%; margin-left: 3%; font-size: 0.9em;">
                      <tr>
                        <th style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          If You Are:
                        </th>
                        <th style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          And the Property is in the Name of:
                        </th>
                        <th style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          Please Submit
                        </th>
                        <th style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          And
                        </th>
                      </tr>
                      <tr>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          The Owner
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          Owner
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          None
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;" />
                      </tr>
                      <tr>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          The Owner
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          Business
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          Articles of Organization for the Business or EIN document
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;" />
                      </tr>
                      <tr>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          A Property Manager or Representative
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          Owner
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          Property management agreement signed by the listed owner
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;" />
                      </tr>
                      <tr>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          A Property Manager or Representative
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          Business
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          Property Management agreement signed by the business authorized signatory
                        </td>
                        <td style="border-width: 2px; border-style: solid; font-size: 0.9em; border-color: black;">
                          Articles of Organization for the business
                        </td>
                      </tr>
                    </table>
                  </h5>
                  <ul id="upload-list-account-documents">
                    <li
                      v-for="file in AuthorizationDocuments"
                      :key="file.id"
                    >
                      <span>{{ file.name }} - </span>
                      <span
                        v-if="file.error"
                        class="is-love-park-red"
                      >
                        Something went wrong - {{ file.errorMessage }}
                      </span>

                      <span
                        v-else-if="file.success"
                        class="is-phanatic-green"
                      >
                        Upload Successful.
                      </span>
                      <span
                        v-else-if="file.uploading"
                        class="is-flyers-orange"
                      >
                        Uploading Document...</span>
                    </li>
                  </ul>
                  <file-upload
                    ref="upload"
                    v-model="AuthorizationDocuments"
                    :input-id="`file-upload-authorization-document`"
                    extensions="gif,jpg,jpeg,png,webp,pdf"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                    :size="1024 * 1024 * 4.5"
                    @input-filter="inputFilter"
                  >
                    <button class="button is-primary">
                      <i class="fa fa-plus" />
                      Select File to Upload
                    </button>
                  </file-upload>
                </div>
                <br>
              </div>
              <div v-if="edpstatus == 1">
                <callout type="warning">
                  <p>* The file upload accepts images and PDFs, with a maximum file size of 4.5mb. You must upload at least one file for each requested document via their individual select buttons. You may upload separate files if you reach the file size limit on a single document.</p>  
                  <p>* After you have uploaded all required files, click the “Finish” button to submit this form.</p>
                  <p>* Do not hit the back button. Wait for the green message that the document has been uploaded before closing this page.</p>
                  <p>
                    After submitting this form, Targeted Financial Assistance documents will be reviewed to ensure all incorrect or missing information was provided.  
                    <br><br>For questions, please email {{ FinancialSpecialistEmail }}.
                  </p>
                </callout>
              </div>
              <div v-if="edpstatus != 1 && (ledger == 1 || bankstatement == 1 || affidavit == 1 || nine == 1 || nor == 1 || ssn == 1 || rentproof == 1 || lease == 1 || (authorization == 1 && PropertyOwnerCheckbox == false))">
                <callout type="warning">
                  <p>*The file upload accepts images and PDFs, with a maximum file size of 4.5mb. You must upload at least one file for each requested document via their individual select buttons. You may upload separate files if you reach the file size limit on a single document.</p>  
                  <p>*After you have uploaded all required files, click the “Finish” button to submit this form.</p>
                  <p>* Do not hit the back button. Wait for the green message that the document has been uploaded before closing this page.</p>
                  <p>
                    After submitting this form, your application will be reviewed to ensure all incorrect or missing information was provided. <br><br> 
                    For questions, please email EvictionDiversionProgram@coraservices.org.
                  </p>
                </callout>
              </div>
            </div>
            <div v-if="(resubmissions > 10)">
              Sorry you have reached your limit on resubmissions
            </div>
            <br>
            <callout v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING" type="danger">
              <b>Please do not naviage away from the page until submitted succesfully</b>
            </callout>
            
            <template #submit>
              <div class="column is-2 is-offset-10">
                <button
                  type="button"
                  :disabled="
                    SubmitStatus.Value === SubmitStatus.Options.PENDING || (filesReady() == false && (WithdrawTFA == 'No' || WithdrawTFA == null))
                  "
                  class="button is-primary"
                  @click="submit"
                >
                  Submit
                </button>
              </div>
              <div class="column">
                <div v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
                  Submitting...
                </div>
                <div v-if="SubmitStatus.Value === SubmitStatus.Options.OK">
                  OK
                </div>
                <div v-if="SubmitStatus.Value === SubmitStatus.Options.ERROR">
                  Error
                </div>
              </div>
            </template>
          </input-form>
        </validationobserver>
      </div>
      <div class="column">
        <div v-if="SubmitStatus.Value === SubmitStatus.Options.PENDING">
          Submitting...
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import options from "@/utilities/options";
import buildLandlordDataFetchObject from "@/utilities/data-objects/landlord-data-fetch-object";
import buildLandlordFileDataObject from "@/utilities/data-objects/landlord-file-data-object";
import buildLandlordBankInfoResubmissionDataObject from "@/utilities/data-objects/landlord-bank-resubmission-data-object";
import buildLandlordResubmissionDataObject from "@/utilities/data-objects/landlord-resubmission-data-object";
import buildCommunicationLogDataObject from "@/utilities/data-objects/communication-log-data-object";
import axios from "axios";
import FileUpload from "vue-upload-component";
import {
  getPropertyValueOrDefault,
  dataObjectToXml,
  resizeImage,
  getBase64,
} from "@/utilities/functions";
import { Callout } from "@phila/phila-ui";

export default {
  name: "ResubmissionPage",
  components: { Callout, FileUpload },
  mixins: [options],
  props: {
    appid: { default: null, type: String },
    llname: { default: null, type: String },
    llphone: { default: null, type: String },
    llemail: { default: null, type: String },
    marname: { default: null, type: String },
    marphone: { default: null, type: String },
    maremail: { default: null, type: String },
    pmrarname: { default: null, type: String },
    pmrarphone: { default: null, type: String },
    pmraremail: { default: null, type: String },
    tname: { default: null, type: String },
    tphone: { default: null, type: String },
    temail: { default: null, type: String },
    licensenumber: { default: null, type: String },
    ledger: { default: null, type: String },
    bankstatement: { default: null, type: String },
    affidavit: { default: null, type: String },
    nine: { default: null, type: String },
    nor: { default: null, type: String },
    ssn: { default: null, type: String },
    rentproof: { default: null, type: String },
    lease: { default: null, type: String },
    authorization: { default: null, type: String },
    businees: { default: null, type: String },
    w9address:{ default: null, type: String },
    bankaccountname: { default: null, type: String },
    tenantaddress:  { default: null, type: String },
    resubmissions: { default: null, type: String },
    edpstatus:  { default: null, type: String },
    largefiler: { default: null, type: String },
    bankrecord: { default: null, type: String },
  },
  data() {
    return {
      WithdrawTFA: null,
      PropertyOwnerCheckbox: false,
      BankInfo: { AccountNumber: null, RoutingNumber: null, BankDocument: [], BankName: null, NameOnBankAccount: null },
      W9Info: { W9Document: [], W9EINNumber: null, SSN: null, Address: { Street1: null, Street2: null, City: null, State: null, Zip: null, Country: "United States" }},
      LedgerDocument: [],
      NoticeOfDiversionRights: [],
      Affidavit: [],
      Lease: [],
      ProofOfRent: [],
      AuthorizationDocuments: [],
      RentalLicenseDocument: [],
      Landlord: {
        ContactInformation: {
          FirstName: null,
          LastName: null,
          CellPhone: null,
          EmailAddress: null,
        },
        RentalLicenseNumber: null, 
        RentalLicenseByLicenseNumIsActive: null,
      },
      PropertyManagementRepresentative: {
        ContactInformation: {
          FirstName: null,
          LastName: null,
          CellPhone: null,
          EmailAddress: null,
          CompanyName: null,
          MediationRepFirstName: null,
          MediationRepLastName: null,
          MediationRepPhone: null,
          MediationRepEmail: null,
          MediationRepCompanyName: null,
        },
        Title: null,
      },
      Tenant: {
        TenantList: [],
        NumberOfTenantsSelected: null,
        ContactInformation: {
          FirstName: null,
          LastName: null,
          CellPhone: null,
          HomePhone: null,
          EmailAddress: null,
          SecondaryFirstName: null,
          SecondaryLastName: null,
          SecondaryEmailAddress: null,
          SecondaryPhoneNumber: null,
          Address: {
            RawAddress: null,
            Candidates: [],
            Street1: null,
            Street2: null,
            City: "Philadelphia",
            State: "Pennsylvania",
            Zip: null,
            Country: "United States",
            OpaNumber: null,
            DorNumber: null,
            PwdNumber: null,
            CouncilDistrict: null,
          },
        },
      },
      TenantComplaint: null,
      LTFillingNumber: null,
      ArrearsChange: null,
      Arrears: null,
      TFAStatus: null,
      EDPStatus: null,
      applicantId: null,
      CorrectedArrears: null,
      initTenantName: null,
      TenantAddress: null,
      FinancialSpecialistEmail: null,
      BankRecordId: null,
      CurrentRentalLicenseNumber: null,
      PropertyOwnerBusinessName: null,
      LedgerNotes: null,
      AffidavitNotes: null,
      BankNotes: null,
      TenantNotes: null,
      AuthorizationNotes: null,
      TenantAddressStreet1: null,
      OwnerEmail: null,
      MaxRIDBankInfo: null,
    };
  },
  created(){
    this.checkForFiles();
    var vData = this;
    let dataObject = buildLandlordDataFetchObject(Number(vData.appid), "TFA_RESUBMISSION_PAGE_GET_LANDLORD_DATA");
    let requestObj = {
      table: process.env.VUE_APP_QB_APPLICATION,
      data: dataObject,
    };
    axios
      .post(
        "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/EDP-TFA-login-QuickBase-Request-Proxy-Reads",
        requestObj,
      )
      .then((response) => {
        const responseObject = getPropertyValueOrDefault(
          ["data", "record", "f"],
          response,
        );
        console.log(responseObject);
        vData.TFAStatus =  getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "714"));
        vData.EDPStatus =  getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "493"));
        vData.applicantId =  getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "62"));
        vData.initTenantName =  getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "101"));
        vData.TenantAddress =  getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "1113"));
        vData.TenantAddressStreet1 =  getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "1114"));
        vData.FinancialSpecialistEmail =  getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "565"));
        vData.CurrentRentalLicenseNumber = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "18"));
        vData.LedgerNotes = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "773"));
        vData.AffidavitNotes = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "774"));
        vData.BankNotes = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "775"));
        vData.TenantNotes = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "776"));
        vData.AuthorizationNotes = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "846"));
        vData.OwnerEmail = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "21"));
        vData.MaxRIDBankInfo = getPropertyValueOrDefault(["_text"], responseObject.find(i => i._attributes.id === "828"));
        vData.BankRecordId = vData.MaxRIDBankInfo;
      });
    
  },
  methods: {
    showValue(id){
      var x = document.getElementById("tb-" + id);
      if (x.type === "password") {
        x.type = "text";
      } else {
        x.type = "password";
      }
    },
    checkForFiles() {
      setInterval(() => {
        this.filesReady();
      }, 1000);
    },
    filesReady(){
      let ready = true;
      if(this.nine == 1 || this.ssn == 1){
        if(this.W9Info.W9Document.length == 0){
          ready = false;
        }
      }
      if(this.bankstatement == 1){
        if(this.BankInfo.BankDocument.length == 0){
          ready = false;
        }
      }
      if(this.ledger == 1){
        if(this.LedgerDocument.length == 0){
          ready = false;
        }
      }
      if(this.affidavit == 1){
        if(this.Affidavit.length == 0){
          ready = false;
        }
      }
      if(this.nor == 1){
        if(this.NoticeOfDiversionRights.length == 0){
          ready = false;
        }
      }
      if(this.rentproof == 1){
        if(this.ProofOfRent.length == 0){
          ready = false;
        }
      }
      if(this.lease == 1){
        if(this.Lease.length == 0){
          ready = false;
        }
      }
      if(this.authorization == 1 && this.PropertyOwnerCheckbox == false){
        if(this.AuthorizationDocuments.length == 0){
          ready = false;
        }
      }
      if(this.licensenumber == 1){
        if(this.RentalLicenseDocument.length == 0){
          ready = false;
        }
      }


      return ready;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|exe?)$/i.test(newFile.name)) {
          alert("Invalid File Type");
          return prevent();
        }
      }
    },
    getRentalLicense() {
      var vData = this;
      vData.Landlord.RentalLicenseByLicenseNumIsActive = null;
      if (
        vData.Landlord.RentalLicenseNumber &&
        vData.Landlord.RentalLicenseNumber.trim().length === 6
      ) {
        axios
          .get(
            `https://phl.carto.com/api/v2/sql?q=SELECT * FROM BUSINESS_LICENSES WHERE licensenum = '${vData.Landlord.RentalLicenseNumber}'`,
          )
          .then((result) => {
            const licenses = getPropertyValueOrDefault(
              ["data", "rows"],
              result,
            );
            const activeLicense = licenses.some(
              (i) => i.licensetype === "Rental" && i.licensestatus === "Active",
            );
            vData.Landlord.RentalLicenseByLicenseNumIsActive = activeLicense;
          });
      }
    },
    async pushFileToQB(file, fileType){
      let vData = this;
      vData.LandlordRecordID = vData.appid;
      try{
        if(vData.LandlordRecordID == null || vData.LandlordRecordID == ""){
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          throw "Landlord Record ID is null";
        }
        var document = await this.getFile(file);
        var documentName= file[0].name;
        const dataObject = await buildLandlordFileDataObject(
          vData.LandlordRecordID,
          documentName,
          document,
          fileType,
          vData.applicantId,
          vData.initTenantName,
          vData.TenantAddressStreet1,
          vData.OwnerEmail,
          vData.largefiler,
          vData.bankrecord,
        );
        const xmlDataObject = await dataObjectToXml(dataObject);
        const requestObj = {
          table: process.env.VUE_APP_QB_FILES,
          action: "API_AddRecord",
          data: xmlDataObject,
        };
        await axios
          .post(
            "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-login-QuickBase-Request-Proxy",
            requestObj,
          )
          .then((qbResult) => {
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;
            file[0].uploading = false;
            file[0].success = true;
          })
          .catch(() => {
            vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
            file[0].errorMessage =
                "File is too large, please reduce your file's size and try again.";
          });
      } catch(err){
        vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
        throw err;
      }
    },
    async getFile(uploadData){
      if (uploadData.length) {
        var vData = this;
        let FileIdx = uploadData.length - 1;
        var fileObj = uploadData[FileIdx];
        fileObj.uploading = true;
        fileObj.error = false;
        fileObj.errorMessage = "";
        let file = fileObj.file;
        if (fileObj.type.match(/image.*/)) {
          file = await resizeImage({ file: file, maxSize: 1920 });
          console.log(file.size);
        }
        if(file.type != "application/pdf" && file.type != "image/png" && file.type != "image/jpeg"){
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          fileObj.error = true;
          fileObj.errorMessage =
              "Wrong file type";
          throw "Wrong File Type";
        }
        if (file.size >= 1024 * 1024 * 4.5) {
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
          fileObj.error = true;
          fileObj.errorMessage =
              "File is too large, please reduce your file's size and try again.";
          throw "File is too large";
        } else {
          return await getBase64(file);
        }
      }
    },
    async addCommunicationRecord(){
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      const isInputValid = await vData.$refs.form.$parent.validate();
      if (isInputValid) {
        try{
          console.log(vData);
          const dataObject = await buildCommunicationLogDataObject(vData);
          const xmlDataObject = await dataObjectToXml(dataObject);
          const requestObject = {
            table: process.env.VUE_APP_QB_COMMUNICATION_LOG,
            action: "API_AddRecord",
            data: xmlDataObject,
          };
        
          await axios
            .post(
              "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-login-QuickBase-Request-Proxy",
              requestObject,
            )
            .then(() => {
            }).catch(err => {
              vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
            });
        } catch(err){
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
        }
      } else{
        vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
      }
    },
    async submitApplicationInfo(){
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      const isInputValid = await vData.$refs.form.$parent.validate();
      if (isInputValid) {
        try{
          console.log(vData);
          const dataObject = await buildLandlordResubmissionDataObject(vData);
          const xmlDataObject = await dataObjectToXml(dataObject);
          const requestObject = {
            table: process.env.VUE_APP_QB_APPLICATION,
            action: "API_EditRecord",
            data: xmlDataObject,
          };
        
          await axios
            .post(
              "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-login-QuickBase-Request-Proxy",
              requestObject,
            )
            .then(() => {
              
            }).catch(err => {
              vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
            });
        } catch(err){
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
        }
      } else{
        vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
      }
    },
    async submitBankInfo(){
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      const isInputValid = await vData.$refs.form.$parent.validate();
      if (isInputValid) {
        try{
          const dataObject = await buildLandlordBankInfoResubmissionDataObject(vData, vData.BankRecordId);
          const xmlDataObject = await dataObjectToXml(dataObject);
          const requestObject = {
            table: process.env.VUE_APP_QB_BANK_INFO,
            action: (this.MaxRIDBankInfo == 0 || this.MaxRIDBankInfo == null) ? "API_AddRecord" : "API_EditRecord",
            data: xmlDataObject,
          };
        
          await axios
            .post(
              "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-login-QuickBase-Request-Proxy",
              requestObject,
            )
            .then(() => {
            }).catch(err => {
              console.log(err);
              vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
            });
        } catch(err){
          console.log(err);
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
        }
      }
    },
    async submitBankInfoLargeFiler(){
      var vData = this;
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      const isInputValid = await vData.$refs.form.$parent.validate();
      if (isInputValid) {
        try{
          const dataObject = await buildLandlordBankInfoResubmissionDataObject(vData, this.bankrecord);
          const xmlDataObject = await dataObjectToXml(dataObject);
          const requestObject = {
            table: process.env.VUE_APP_QB_BANK_INFO,
            action: "API_EditRecord",
            data: xmlDataObject,
          };
        
          await axios
            .post(
              "https://djql8jp3sb.execute-api.us-east-1.amazonaws.com/V1/Eviction-Diversion-login-QuickBase-Request-Proxy",
              requestObject,
            )
            .then(() => {
              
            }).catch(err => {
              console.log(err);
              vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
            });
        } catch(err){
          console.log(err);
          vData.SubmitStatus.Value = vData.SubmitStatus.Options.ERROR;
        }
      }
    },
    async submit(){
      var vData = this;
      const isInputValid = await vData.$refs.form.$parent.validate();
      vData.SubmitStatus.Value = vData.SubmitStatus.Options.PENDING;
      if (isInputValid) {

        if(this.WithdrawTFA == "No" || this.WithdrawTFA == null){
          if(this.bankstatement == 1){
            await this.pushFileToQB(this.BankInfo.BankDocument, "Bank Account Document");
          }
          if(this.affidavit == 1){
            await this.pushFileToQB(this.Affidavit, "Signed Landlord Affidavit");
          }
          if(this.authorization == 1 && this.PropertyOwnerCheckbox == false) {
            await this.pushFileToQB(this.AuthorizationDocuments, "Property Authorization Form");
          }
          if(this.nine == 1 || this.ssn == 1){
            await this.pushFileToQB(this.W9Info.W9Document, "W9");
          }
          if(this.ledger == 1){
            await this.pushFileToQB(this.LedgerDocument, "Ledger");
          }
          if(this.nor == 1){
            await this.pushFileToQB(this.NoticeOfDiversionRights, "Notification of Diversion Rights");
          }
          if(this.rentproof == 1){
            await this.pushFileToQB(this.ProofOfRent, "Proof of Rent");
          }
          if(this.lease == 1){
            await this.pushFileToQB(this.Lease, "Lease");
          }
          if(this.licensenumber == 1){
            await this.pushFileToQB(this.RentalLicenseDocument, "Rental License");
          }
        }

        if((this.bankstatement == 1 || this.nine == 1 || this.ssn == 1) && this.largefiler == 0){
          await this.submitBankInfo();
        }

        if(this.largefiler == 1){
          await this.submitBankInfoLargeFiler();
        }

        await this.submitApplicationInfo();

        await this.addCommunicationRecord();

        vData.SubmitStatus.Value = vData.SubmitStatus.Options.OK;

        if(this.edpstatus != 1){
          this.$router.push({
            name: "ResubmissionSuccess",
          });
        }
        if(this.edpstatus == 1){
          this.$router.push({
            name: "ResubmissionTFASuccess",
            params: { financialSpecialistEmail: this.FinancialSpecialistEmail },
          });
        }
      }

    },
  },
};
</script>